import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class AgentDirectory {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    scrollToTop() {
        let headerht = $('header').innerHeight();
        $('html, body').stop().animate({
            scrollTop: $('.hero').offset().top - (headerht)
        }, {
            duration: 750
        });
    }

    showListingByState(state) {
        // clear current state
        $('.state-grouping').addClass('hidden');
        // show selected state or all
        if (state === 'All') {
            $('.state-grouping').removeClass('hidden');
            $('.state-grouping').children().removeClass('state-last-child');
        } else {
            $(`.state-grouping[data-state="state-${state}"]`).removeClass('hidden');
            $(`.state-grouping[data-state="state-${state}"]`).children().filter('.return-to-top').addClass('state-last-child');
        }
    }

    bindEvents() {
        $('.return-to-top a').on('click', (e) => {
            e.preventDefault();
            this.scrollToTop();
            // $(e.target).addClass('open').removeClass('closed');
        });

        // $('#state-select').on('focus', (e) => {
        //     e.preventDefault();
        //     $(e.target).addClass('open').removeClass('closed');
        //     console.log('focus');
        // });

        // $('#state-select').on('blur', (e) => {
        //     e.preventDefault();
        //     $(e.target).removeClass('open').addClass('closed');
        //     console.log('blur');
        // });

        $('#state-select').on('change', (e) => {
            e.preventDefault();
            let val = $(e.target).val();
            this.showListingByState(val);
            // $(e.target).removeClass('open').addClass('closed');
			$(e.target).blur();
        });
    }
}

export default AgentDirectory;

$(() => {
	const agentDirectory = new AgentDirectory();
	agentDirectory.init();
});